var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 6.75H7.5C6.50544 6.75 5.55161 7.14509 4.84835 7.84835C4.14509 8.55161 3.75 9.50544 3.75 10.5V37.5C3.75 38.4946 4.14509 39.4484 4.84835 40.1516C5.55161 40.8549 6.50544 41.25 7.5 41.25H40.5C41.4946 41.25 42.4484 40.8549 43.1516 40.1516C43.8549 39.4484 44.25 38.4946 44.25 37.5V10.5C44.25 9.50544 43.8549 8.55161 43.1516 7.84835C42.4484 7.14509 41.4946 6.75 40.5 6.75ZM39.75 36.75H8.25V11.25H39.75V36.75ZM11.25 17.25C11.25 16.6567 11.4259 16.0766 11.7556 15.5833C12.0852 15.0899 12.5538 14.7054 13.1019 14.4784C13.6501 14.2513 14.2533 14.1919 14.8353 14.3076C15.4172 14.4234 15.9518 14.7091 16.3713 15.1287C16.7909 15.5482 17.0766 16.0828 17.1924 16.6647C17.3081 17.2467 17.2487 17.8499 17.0216 18.3981C16.7946 18.9462 16.4101 19.4148 15.9167 19.7444C15.4234 20.0741 14.8433 20.25 14.25 20.25C13.4544 20.25 12.6913 19.9339 12.1287 19.3713C11.5661 18.8087 11.25 18.0456 11.25 17.25ZM20.25 17.25C20.25 16.6567 20.4259 16.0766 20.7556 15.5833C21.0852 15.0899 21.5538 14.7054 22.1019 14.4784C22.6501 14.2513 23.2533 14.1919 23.8353 14.3076C24.4172 14.4234 24.9518 14.7091 25.3713 15.1287C25.7909 15.5482 26.0766 16.0828 26.1924 16.6647C26.3081 17.2467 26.2487 17.8499 26.0216 18.3981C25.7946 18.9462 25.4101 19.4148 24.9167 19.7444C24.4234 20.0741 23.8433 20.25 23.25 20.25C22.4544 20.25 21.6913 19.9339 21.1287 19.3713C20.5661 18.8087 20.25 18.0456 20.25 17.25Z",
    fill: "url(#paint0_linear_1559_2682)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_2682",
    x1: 24,
    y1: 6.75,
    x2: 24,
    y2: 41.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppWindow);
export default __webpack_public_path__ + "static/media/AppWindow.2a7ce8b435f59c277e51fe826fea1b88.svg";
export { ForwardRef as ReactComponent };